<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'App',
  components: {},
  mounted () {
    // this.getAllrights({});
  },
  updated () {
    this.$common.isHaveAuthor(1001, 0)
  },
  methods: {
    ...mapActions('permissions', ['getAllrights'])
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue